import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import { noArtworkTitle, noArtworkBtn, noArtworkSale } from '../../constants/artwork'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.bsBg10};
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 1px 10px rgba(168, 121, 0, 0.13)'};
  border-radius: 40px;
  width: 616px;
  overflow: hidden;
  margin-top: 12px;
  padding: 32px 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
`
const Title = styled.div`
  color: ${({ theme }) => theme.primary1};
  margin: 0 0 26px;
  font-family: Baloo Da;
  font-size: 18px;
`
const Title1 = styled(Title)`
  margin: 32px 0 26px;
`
const ImgArtwork = styled.img`
  width: 76px;
  height: auto;
  margin-bottom: 40px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 16px;
  `}
`
const GoArtworks = styled(NavLink)`
  display: inline-block;
  background: ${({ theme }) => theme.primary1 };
  color: ${({ theme }) => theme.bsText1 };
  border-radius: 10px;
  width: 240px;
  font-family: Baloo Da;
  font-size: 14px;
  text-decoration: none;
  line-height: 40px;
  text-align: center;
`

export default function NoArtworks({type, ownBtn, status, nftTypeQuery}: {type: string, nftTypeQuery?: [], ownBtn?: boolean, status?: number}) {
  const query = nftTypeQuery ? nftTypeQuery.join(',') : '111,3'
  const title = noArtworkTitle[type] || "You don't have any NFT"
  const statusText = noArtworkSale[type] || 'There is no NFT on sale'
  const btnText = noArtworkBtn[type] || 'Go to Exchange'
  const url = query === '2'
              ? '/exchange/binance-nft' 
              : query === '104' 
              ? '/exchange/doggynft'
              : query === '108' 
              ? '/exchange/barkingnft'
              : query === '114' 
              ? '/exchange/doggyEquipment'
              : query === '106' 
              ? '/exchange/pokernft'
              : query === '103' 
              ? '/exchange/rareCar'
              : query === '100' 
              ? '/exchange/bakerySoccer'
              : `/exchange/bakery-artworks/${query}`
  return (
    <Wrapper>
      {
        ownBtn
          ? <Title>{title}</Title>
          : !status
              ? <Title1>There is no NFT on pending</Title1>
              : <Title1>{statusText}</Title1>
      }
      <ImgArtwork src="/images/artworks/no_art.png" alt="unknown-artwork"/>
      {
        ownBtn && <GoArtworks to={url}> { btnText }</GoArtworks>
      }
    </Wrapper>
  )
}